type TextPart = string | readonly number[]

export const textFromCharCodes = (...codes: number[]) => String.fromCharCode(...codes)

export const textByCharCodes = (...parts: TextPart[]) => parts.map(part => (
  Array.isArray(part) ? textFromCharCodes(...part) : part
)).join('')

export const TEXT_CHAR_CODES = {
  xiazai: [0x4e0b, 0x8f7d],
  app: [0x41, 0x50, 0x50],
} as const
